
import React, { useState, useEffect } from "react";
import axios from "../../axios";
import { get } from "lodash";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import { Field, Form, Formik } from "formik";
import "react-datepicker/dist/react-datepicker.css";
import "./BlockManagement.css";
import Cookies from "js-cookie";
import { Icons, toast } from "react-toastify";
import { useNavigate, useParams, useLocation } from "react-router-dom";
// import JoditEditor from "jodit-react";

import Input from "../../components/Input";
import { Modal } from "../../components/Modal";
import Overlay from "../../components/Overlay";
import TextArea from "../../components/TextArea";

import { subAdminValidator } from "../../utils/validators";
import {
  extractDate,
  uploadImage,
  subadminAccessChange,
} from "../../utils/functions";

// Mui & material UI
import { makeStyles } from "@material-ui/core/styles";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

// React Icons
import { HiArrowNarrowLeft } from "react-icons/hi";

// Elements
import {
  DashboardContainer,
  DashboardWrapper,
  DashboardHeading,
  DashHeading,
  Button,
  Fields,
  ProfileDetailForm,
} from "./BlockElement";
import { FaQ } from "react-icons/fa6";

const useStyles = makeStyles((theme) => ({
  paperTableHeight: {
    width: "97%",
    marginLeft: "1rem",
    // minHeight: "87vh",
    border: "1px solid rgba(12, 45, 6, 0.10)",
    borderRadius: "10px",
  },
}));

const AddUpdateBlock = ({ setUsers, userData }) => {
  const classes = useStyles();

  const location = useLocation();
  const block = location.state?.blockData; // Retrieve FAQ data if passed
  // console.log("gfjwdjc",location)
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  // Handle Create & Update FAQs
  const handleSubmit = async (values) => {

    setIsLoading(true);
    try {
      values['word'] = values['word'].toLowerCase() 
      
      const apiCall = block
        ? axios.put(`private/updateBlackListWord/${values.block_id}`, values)
        : axios.post(`/private/createBlackListWord`, values);


      const { data } = await apiCall;
      toast.success(data?.message);
      navigate("/blockManagement");
    } catch (error) {
      if (error?.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        setUsers("");

        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });

        navigate("/");
      } else if (error?.response?.status === 901) {
        subadminAccessChange(navigate);
        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });
      } else {
        console.log("error", error?.response)
      }
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <DashboardContainer>
        <DashboardWrapper>
          <ProfileDetailForm>
            <div
              style={{ cursor: "pointer" }}
              className="d-flex align-items-center"
              onClick={() => {
                navigate("/blockManagement");
              }}
            >
              <HiArrowNarrowLeft style={{ fontSize: "1.2rem" }} />
              <div className="common-heading ps-2">
                {/* {?._id ? "Update " : "Add New"}                            */}
                {block ? "Edit" : "Add New"}
              </div>
            </div>

            <DashboardHeading>
              <Formik
                enableReinitialize
                initialValues={{
                  word: block?.word || "",
                  block_id: block?._id || "",
                }}
                validate={(values) => {
                  const errors = {};
                  const trimmedWord = values.word.replace(/\s/g, "");

                  if (!trimmedWord) {
                    errors.word = "Word is required";
                  }

                  return errors;
                }}
                onSubmit={handleSubmit}
              >
                {({ values, handleChange, setFieldValue, errors, touched }) => (
                  <Form
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      gap: "1rem",
                    }}
                  >
                    <div className="main_box">
                      <label className="lablename">Blacklist Word</label>
                      <input
                        name="word"
                        className="form-controll"
                        placeholder="Enter word"
                        value={values.word}
                        maxLength={10}
                        onChange={handleChange}
                        style={{ padding: "1rem" }}
                      />
                      <div style={{ textAlign: 'right', fontSize: '14px', color: '#5088FB' }}>
                        {values.word.replace(/\s/g, "").length}/10
                      </div>
                      {errors.word && touched.word && (
                        <div style={{ color: "red", fontSize: "0.8rem", fontWeight: "400" }}>{errors.word}</div>
                      )}

                      <div style={{ marginTop: "1rem", display: "flex", gap: "1rem" }}>
                        <Button
                          style={{
                            background: "#5088FB",
                            border: "none",
                            color: "#FFFFFF",
                            width: "5rem"
                          }}
                          type="submit"
                          disabled={isLoading}
                        >
                          {/* {isLoading ? "Saving..." : block ? "Edit" : "Create"} */}
                          Save
                        </Button>
                        <Button
                          style={{
                            background: "#FFFFFF",
                            color: "#26344E",
                            border: "1px solid #26344E38",
                          }}
                          onClick={() => {
                            navigate("/blockManagement");
                          }}
                        >
                          Cancel
                        </Button>

                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </DashboardHeading>
          </ProfileDetailForm>
        </DashboardWrapper>
      </DashboardContainer>

      {isLoading && <Overlay />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
    sidebar: state.sidebar,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
    setSidebar: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_SIDEBAR,
        updateSidebar: updatedValue,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddUpdateBlock);

